import { useAuthenticatedUser } from 'features/authentication';
import { usePermissions } from 'features/permissions';

export function useManageJobAccess(createdById: number) {
  const me = useAuthenticatedUser();
  const { hasRolePermission } = usePermissions();

  return me.id === createdById || hasRolePermission('job:access:manage');
}
